module.exports = __webpack_public_path__ + "img/AG.3861ab35.png";